'use client';

import { useSidebar } from '#/components/ui/sidebar';
import { useEffect } from 'react';
import { create } from 'zustand';

export type SidebarContextProps = ReturnType<typeof useSidebar>;

export interface SidebarState {
  sidebar: SidebarContextProps | null;
}

export interface SidebarAction {
  setSidebar: (sidebar: SidebarContextProps) => void;
}

export const useAppSidebarStore = create<SidebarState & SidebarAction>(set => ({
  sidebar: null,
  setSidebar: sidebar => set(() => ({ sidebar })),
}));

export function AppSidebarStoreBridge() {
  const sidebar = useSidebar();
  const setSidebar = useAppSidebarStore(state => state.setSidebar);
  useEffect(() => {
    setSidebar(sidebar);
  }, [sidebar, setSidebar]);
  return null;
}
